import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default class DashboardPro extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null
        };
    }

    componentDidMount() {
        this.fetchDashboard();
    }

    fetchDashboard() {
        this.setState({ loading: true });
        this.httpPost('api/v1/dashboard/comprehensive', {})
            .then(res => {
                if (res.status === 1) this.setState({ data: res, loading: false });
                else if (res.status === -5) window.location.href = "/access-denied"; else { this.showErorrMessage(res.message); this.setState({ loading: false }); }
            });
    }

    renderForm() {
        if (this.state.loading) return this.renderLoading();

        const { summary, taskStatusCounts, productivity, expiringContracts } = this.state.data;

        const statusLabels = ['جدید', 'در حال انجام', 'نیازمند مدارک', 'بررسی سرپرست', 'تکمیل شده'];
        const statusColors = ['#ffc107', '#fd7e14', '#0d47a1', '#e74c3c', '#28a745'];
        const pieData = {
            labels: statusLabels,
            datasets: [{
                data: taskStatusCounts.map(s => s.count),
                backgroundColor: statusColors
            }]
        };

        const barData = {
            labels: productivity.map(p => p.userName),
            datasets: [{
                label: 'کارهای تکمیل‌شده',
                data: productivity.map(p => p.completedCount),
                backgroundColor: '#6366f1'
            }]
        };

        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">داشبورد مدیریتی</h3>
                        </div>
                    </div>
                </div>

                <div className="row g-4 mb-4">
                    <div className="col-md-3">
                        <div className="card card-bordered h-100 dash-stat-card">
                            <div className="card-inner">
                                <h6>مشتریان فعال</h6>
                                <h2>{summary.totalCustomers}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-bordered h-100 dash-stat-card">
                            <div className="card-inner">
                                <h6>قراردادهای جاری</h6>
                                <h2>{summary.totalContracts}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-bordered h-100 dash-stat-card">
                            <div className="card-inner">
                                <h6>وظایف باز</h6>
                                <h2>{summary.totalTasks}</h2>
                                <small className="text-danger">{summary.totalOverdueTasks} عقب‌افتاده</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-bordered h-100 dash-stat-card">
                            <div className="card-inner">
                                <h6>درآمد کل / بدهی</h6>
                                <h2>{this.money(summary.totalRevenue)}</h2>
                                <small>بدهی: {this.money(summary.totalDebt)}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-4 mb-4">
                    <div className="col-md-6">
                        <div className="card card-bordered h-100">
                            <div className="card-inner d-flex flex-column">
                                <h5>وضعیت وظایف</h5>
                                <div style={{ position: 'relative', flex: 1, minHeight: '250px' }}>
                                    <Pie data={pieData} options={{ maintainAspectRatio: false }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card card-bordered h-100">
                            <div className="card-inner d-flex flex-column">
                                <h5>بهره‌وری (تکمیل‌شده)</h5>
                                <div style={{ position: 'relative', flex: 1, minHeight: '250px' }}>
                                    <Bar data={barData} options={{ maintainAspectRatio: false, scales: { y: { beginAtZero: true } } }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-bordered">
                    <div className="card-inner">
                        <h5>قراردادهای نزدیک به پایان</h5>
                        <table className="table table-bordered">
                            <thead><tr><th>مشتری</th><th>تاریخ پایان</th></tr></thead>
                            <tbody>
                                {expiringContracts.map(c => (
                                    <tr key={c.contractId}>
                                        <td>{c.customerName}</td>
                                        <td>{c.endDatePersian}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        {this.renderForm()}
                    </div>
                </div>
            </div>,
            <Footer />
        ];

        return contents;
    }
}